<template>
  <v-layout align-start>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-flex>
      <v-dialog v-model="dialogCancell" transition="dialog-bottom-transition" max-width="600">
        <v-toolbar color="primary" dark>
          <h3>Confirmación de Cancelación</h3>
        </v-toolbar>
        <v-card>
          <v-card-text class="pa-7">
            <span class="">Si cancelas esta solicitud de acceso de vehiculos y personal, ya no podrá ser modificada
              ni enviada nuevamente. ¿Estás seguro de que deseas continuar?</span>

            <v-row dense>
              <v-col sm="12" lg="12">
                <v-form class="pa-5" v-model="isFormCancellValid" ref="form_cancell">
                  <v-textarea v-model="motivo_cancell" outlined label="Motivo de cancelación" :rules="[rules.required]"
                    required></v-textarea>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>

            <v-btn :loading="loading" color="primary" :disabled="!isFormCancellValid" @click="cancellSolicitud()" block>
              Cancelar solicitud
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogDocumentos"
        :max-width="$vuetify.breakpoint.xsOnly ? '100%' : 1000"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        scrollable
      >
        <v-card>
          <v-toolbar color="primary" dark dense flat>
            <v-icon left>folder_open</v-icon>
            <v-toolbar-title class="text-body-1 font-weight-medium">Documentación adjunta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogDocumentos = false; pdfLink = null">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-0">
            <v-row no-gutters style="min-height: 500px;">

              <!-- Panel izquierdo: lista de archivos -->
              <v-col
                cols="12"
                md="4"
                :style="$vuetify.breakpoint.mdAndUp ? 'border-right: 1px solid #e0e0e0;' : ''"
              >
                <v-list dense class="pa-0">

                  <!-- Sección Vehículos -->
                  <v-subheader class="font-weight-bold text--primary">
                    <v-icon small left color="primary">directions_car</v-icon>Vehículos
                  </v-subheader>

                  <template v-if="documentos_vehiculos_vis.length > 0">
                    <v-list-item
                      v-for="(file, index) in documentos_vehiculos_vis"
                      :key="'veh-' + index"
                      @click="viewPdf(file)"
                      :class="{ 'primary lighten-5': pdfLink === file }"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon :color="pdfLink === file ? 'primary' : 'blue lighten-1'">picture_as_pdf</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Documento {{ index + 1 }}</v-list-item-title>
                        <v-list-item-subtitle>PDF</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action v-if="pdfLink === file">
                        <v-icon small color="primary">visibility</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                  <v-list-item v-else>
                    <v-list-item-content>
                      <v-list-item-subtitle class="text-center font-italic">Sin documentos</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider class="my-1"></v-divider>

                  <!-- Sección Personal -->
                  <v-subheader class="font-weight-bold text--primary">
                    <v-icon small left color="primary">badge</v-icon>Personal
                  </v-subheader>

                  <template v-if="documentos_personal_vis.length > 0">
                    <v-list-item
                      v-for="(file, index) in documentos_personal_vis"
                      :key="'per-' + index"
                      @click="viewPdf(file)"
                      :class="{ 'primary lighten-5': pdfLink === file }"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon :color="pdfLink === file ? 'primary' : 'blue lighten-1'">picture_as_pdf</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Documento {{ index + 1 }}</v-list-item-title>
                        <v-list-item-subtitle>PDF</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action v-if="pdfLink === file">
                        <v-icon small color="primary">visibility</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                  <v-list-item v-else>
                    <v-list-item-content>
                      <v-list-item-subtitle class="text-center font-italic">Sin documentos</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                </v-list>

                <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
              </v-col>

              <!-- Panel derecho: visor de PDF -->
              <v-col cols="12" md="8" class="pa-0">
                <div v-if="pdfLink" style="height: 100%;">
                  <iframe
                    :src="pdfLink"
                    width="100%"
                    :height="$vuetify.breakpoint.smAndDown ? '420px' : '620px'"
                    style="border: none; display: block;"
                  ></iframe>
                </div>
                <div
                  v-else
                  class="d-flex flex-column align-center justify-center text--secondary"
                  :style="{ height: $vuetify.breakpoint.smAndDown ? '180px' : '620px' }"
                >
                  <v-icon size="48" color="grey lighten-1">picture_as_pdf</v-icon>
                  <span class="mt-2 text-body-2">Selecciona un documento para verlo</span>
                </div>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAut1" max-width="500px">
        <v-card>
          <v-toolbar color="primary" dark>Autorizar solicitud de acceso</v-toolbar>
          <v-container>
            <v-row v-if="itemSelected.embarcacion">
              <v-col cols="12">
                <p style="font-size: 14px; color: gray">
                  Se ha recibido la solicitud
                  <strong>#{{ itemSelected.counter }}</strong> para que ingrese personal a la
                  embarcación <strong>{{ itemSelected.embarcacion.nombre }}</strong> en el
                  muelle <strong>{{ itemSelected.muelle }}</strong>. Por favor, confirme si autoriza este acceso.
                </p>

                <v-row v-if="itemSelected.embarcacion">

                  <v-col cols="6">
                    <span style="font-size: 12px">Personal:</span>

                    <ul>
                      <li style="font-size: 12px" v-for="(item, index) in itemSelected.pasajeros" :key="index">
                        {{ item.nombre_completo }}

                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="6">
                    <span style="font-size: 12px">Vehiculos:</span>

                    <ul>
                      <li style="font-size: 12px" v-for="(item, index) in itemSelected.vehiculos" :key="index">
                        {{ item.marca }} {{ item.tipo }}

                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAut1 = false">Salir</v-btn>
            <v-btn color="blue darken-1" :loading="loading" text @click="activar">Autorizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAut2" max-width="500px">
        <v-card>
          <v-toolbar color="primary" dark>Autorizar solicitud de acceso</v-toolbar>

          <v-container>
            <v-row v-if="itemSelected.embarcacion">
              <v-col cols="12">
                <p style="font-size: 14px; color: gray">
                  Se ha recibido la solicitud
                  <strong>#{{ itemSelected.folio }}</strong> para que ingrese personal a la
                  embarcación <strong>{{ itemSelected.embarcacion.nombre }}</strong> en el
                  muelle <strong>{{ itemSelected.muelle }}</strong>. Por favor, confirme si autoriza este acceso.
                </p>

                <v-row v-if="itemSelected.embarcacion">

                  <v-col cols="6">
                    <span style="font-size: 12px">Personal:</span>

                    <ul>
                      <li style="font-size: 12px" v-for="(item, index) in itemSelected.pasajeros" :key="index">
                        {{ item.nombre_completo }}

                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="6">
                    <span style="font-size: 12px">Vehiculos:</span>

                    <ul>
                      <li style="font-size: 12px" v-for="(item, index) in itemSelected.vehiculos" :key="index">
                        {{ item.marca }} {{ item.tipo }}

                      </li>
                    </ul>
                  </v-col>
                </v-row>


              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAut2 = false">Salir</v-btn>
            <v-btn color="blue darken-1" :loading="loading" text @click="autorizarOpib">Autorizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="pb-10 d-flex align-center justify-space-between flex-wrap" style="gap: 12px">
        <div>
          <h2>Solicitudes de acceso de vehiculos y personal</h2>
          <span style="font-size: 13px; color: gray">
            Solicita y gestiona pases de acceso al muelle.
          </span>
        </div>

        <v-btn v-if="usuario_log.rol == 'Agencia' || usuario_log.rol == 'root'" @click="mostrarNuevo()">Nueva
          Solicitud</v-btn>
      </div>

      <v-dialog
        v-model="dialogNuevaSolicitud"
        transition="dialog-bottom-transition"
        :max-width="$vuetify.breakpoint.xsOnly ? '100%' : 1000"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        scrollable
      >
        <v-card>
          <v-toolbar color="primary" dark dense flat>
            <v-toolbar-title class="text-body-1 font-weight-medium">
              {{ editedIndex ? "Editar solicitud de acceso" : "Nueva solicitud de acceso" }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogNuevaSolicitud = false; limpiar()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-0">
            <v-stepper v-model="e1" elevation="0">
              <loading-overlay :overlay="loading"></loading-overlay>

              <!-- Header con scroll horizontal en móvil -->
              <div style="overflow-x: auto; -webkit-overflow-scrolling: touch;">
                <v-stepper-header style="min-width: 480px;">
                  <v-stepper-step :complete="e1 > 1" step="1">Datos</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 2" step="2">Personal</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 3" step="3">Vehículos</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 4" step="4">Detalles</v-stepper-step>
                </v-stepper-header>
              </div>

              <v-stepper-items>
                <!-- ── STEP 1: Datos de la solicitud ── -->
                <v-stepper-content step="1" class="pa-3 pa-sm-5">

                  <!-- Autocompletar con folio -->
                  <v-row align="center" class="mb-1">
                    <v-col cols="12" sm="5">
                      <v-text-field
                        v-model="buscarFolio"
                        outlined dense hide-details
                        label="Autocompletar con folio"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="auto">
                      <v-btn
                        color="primary"
                        @click="buscar_folio"
                        :block="$vuetify.breakpoint.xsOnly"
                      >Buscar</v-btn>
                    </v-col>
                  </v-row>

                  <v-divider class="my-3"></v-divider>

                  <!-- Tipo de solicitante -->
                  <div class="text-caption text--secondary mb-0">Tipo de solicitante</div>
                  <v-radio-group v-model="tipo" row class="mt-1 mb-0" hide-details>
                    <v-radio label="Proveedor" value="Proveedor"></v-radio>
                    <v-radio label="Cesionario" value="Cesionario"></v-radio>
                    <v-radio label="Contratista" value="Contratista"></v-radio>
                    <v-radio label="Armador" value="Armador"></v-radio>
                  </v-radio-group>

                  <v-row class="mt-3">
                    <!-- Periodo de estadía -->
                    <v-col cols="12" sm="6">
                      <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="dateRangeText"
                            label="Periodo de estadía"
                            readonly dense outlined
                            v-bind="attrs" v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="dates" range scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <!-- Muelle -->
                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        :items="muelles"
                        v-on="on"
                        label="Muelle"
                        outlined dense hide-details
                        v-model="muelle"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Embarcación -->
                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        v-model="embarcacion"
                        hide-details
                        label="Embarcación"
                        outlined dense
                        :items="embarcaciones"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Compañía / Proveedor -->
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-if="tipo !== 'Proveedor'"
                        v-model="compania"
                        outlined dense
                        label="Compañía"
                      ></v-text-field>
                      <v-autocomplete
                        v-if="tipo === 'Proveedor'"
                        v-model="compania"
                        outlined dense
                        label="Proveedor"
                        :items="ListaPSP"
                        item-text="label"
                        item-value="value"
                        :item-disabled="psp => psp.estatus === 'Impago'"
                      >
                        <template v-slot:item="{ item }">
                          <span :style="{ color: item.estatus === 'Impago' ? '#ada6a6' : 'black' }">
                            {{ item.razon_social }}
                            <template v-if="item.estatus !== 'Al corriente'"> — {{ item.estatus }}</template>
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <!-- Al servicio de (solo Proveedor) -->
                    <v-col cols="12" sm="6" v-if="tipo === 'Proveedor'">
                      <v-text-field
                        v-model="al_servicio_de"
                        outlined dense
                        label="Embarcación al servicio de"
                      ></v-text-field>
                    </v-col>

                    <!-- Checkboxes de material -->
                    <v-col cols="12" sm="6">
                      <v-checkbox v-model="ingreso_mat" label="Ingreso de material o equipo" class="mt-0" hide-details></v-checkbox>
                      <v-checkbox v-model="retiro_mat" label="Retiro de material o equipo" class="mt-2" hide-details></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-row class="mt-4">
                    <v-col cols="12" class="d-flex">
                      <v-btn color="primary" @click="checkDataStepper(1)">
                        <v-icon left>arrow_forward</v-icon>Continuar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!-- ── STEP 2: Lista del personal ── -->
                <v-stepper-content step="2" class="pa-3 pa-sm-5">
                  <v-row align="center" class="mb-3">
                    <v-col cols="auto">
                      <v-btn small color="primary" @click="agregarDetalle()">
                        <v-icon left small>group_add</v-icon>Agregar personal
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="cabeceraDetalles"
                    :items="pasajeros"
                    class="elevation-1"
                    mobile-breakpoint="600"
                  >
                    <template v-slot:item.borrar="{ item }">
                      <v-btn icon small color="error" @click="eliminarPasajero(pasajeros, item)">
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.nombre_completo="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.nombre_completo"></v-text-field>
                    </template>
                    <template v-slot:item.compania="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.compania" :disabled="tipo === 'Proveedor'"></v-text-field>
                    </template>
                    <template v-slot:item.puesto="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.puesto"></v-text-field>
                    </template>
                    <template v-slot:item.licencia="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.licencia"></v-text-field>
                    </template>
                  </v-data-table>

                  <div v-if="submited && !$v.pasajeros.required" class="mt-2">
                    <v-alert v-model="alert" dismissible color="red" border="left" elevation="2" colored-border icon="error">
                      <strong>Error:</strong> el campo pasajero es requerido
                    </v-alert>
                  </div>

                  <v-row class="mt-4">
                    <v-col cols="12" class="d-flex">
                      <v-btn small color="primary" @click="checkDataStepper(2)">
                        <v-icon left small>arrow_forward</v-icon>Continuar
                      </v-btn>
                      <v-btn small text class="ml-2" @click="e1 = 1">
                        <v-icon left small>arrow_back</v-icon>Regresar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!-- ── STEP 3: Lista de vehículos ── -->
                <v-stepper-content step="3" class="pa-3 pa-sm-5">
                  <v-row align="center" class="mb-3">
                    <v-col cols="auto">
                      <v-btn small color="primary" @click="agregarVehiculos()">
                        <v-icon left small>directions_car</v-icon>Agregar vehículo
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="cabeceraVehiculos"
                    :items="vehiculos"
                    class="elevation-1"
                    mobile-breakpoint="600"
                  >
                    <template v-slot:item.borrar="{ item }">
                      <v-btn icon small color="error" @click="eliminarVehiculo(vehiculos, item)">
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.marca="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.marca"></v-text-field>
                    </template>
                    <template v-slot:item.placa="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.placa"></v-text-field>
                    </template>
                    <template v-slot:item.vigenciaSeguro="{ item }">
                      <input
                        type="date"
                        v-model="item.vigenciaSeguro"
                        style="border: 1px solid #9e9e9e; border-radius: 4px; padding: 4px 8px; font-size: 14px; width: 100%;"
                      />
                    </template>
                    <template v-slot:item.color="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.color"></v-text-field>
                    </template>
                    <template v-slot:item.tipo="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.tipo"></v-text-field>
                    </template>
                    <template v-slot:item.compania_aseguradora="{ item }">
                      <v-text-field clearable dense hide-details v-model="item.compania_aseguradora"></v-text-field>
                    </template>
                  </v-data-table>

                  <v-row class="mt-4">
                    <v-col cols="12" class="d-flex">
                      <v-btn small color="primary" @click="checkDataStepper(3)">
                        <v-icon left small>arrow_forward</v-icon>Continuar
                      </v-btn>
                      <v-btn small text class="ml-2" @click="e1 = 2">
                        <v-icon left small>arrow_back</v-icon>Regresar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!-- ── STEP 4: Detalles y adjuntos ── -->
                <v-stepper-content step="4" class="pa-3 pa-sm-5">
                  <v-row>
                    <v-col cols="12" sm="6" v-if="vehiculos.length > 0">
                      <div class="text-subtitle-2 mb-2">Documentos de vehículos</div>
                      <v-file-input
                        small-chips
                        @change="validateFileSize"
                        :rules="fileRules"
                        multiple
                        v-model="file2"
                        dense accept=".pdf"
                        outlined
                      ></v-file-input>
                      <v-row
                        style="margin-top: -15px"
                        v-for="(item, index) in nombreArchivo2"
                        :key="'veh-' + index"
                        align="center"
                      >
                        <v-col cols="auto">
                          <v-btn class="ma-1" dark x-small @click="descargarAdjuntos(item)">
                            <v-icon dark x-small left>file_download</v-icon>Documento {{ index + 1 }}
                          </v-btn>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn class="ma-1" text x-small icon @click="eliminarAdjuntoVehiculo(nombreArchivo2, item)" color="red">
                            <v-icon>backspace</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <div class="text-subtitle-2 mb-2">Documentos del personal</div>
                      <v-file-input
                        small-chips
                        @change="validateFileSizePersonal"
                        multiple dense accept=".pdf"
                        v-model="file3"
                        :rules="fileRulesPersonal"
                        outlined
                      ></v-file-input>
                      <v-row
                        style="margin-top: -15px"
                        v-for="(item, index) in nombreArchivo"
                        :key="'per-' + index"
                        align="center"
                      >
                        <v-col cols="auto">
                          <v-btn class="ma-1" dark x-small @click="descargarAdjuntos(item)">
                            <v-icon dark x-small left>file_download</v-icon>Documento {{ index + 1 }}
                          </v-btn>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn class="ma-1" x-small icon @click="eliminarAdjuntoPersonal(nombreArchivo, item)" color="red">
                            <v-icon>backspace</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-textarea
                        v-model="detalles"
                        outlined dense clearable
                        label="Motivo de la visita"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row class="mt-2">
                    <v-col cols="12" class="d-flex">
                      <v-btn color="primary" @click="checkDataStepper(4)">
                        <v-icon left>save</v-icon>Guardar
                      </v-btn>
                      <v-btn text class="ml-2" @click="e1 = 3">
                        <v-icon left small>arrow_back</v-icon>Regresar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!-- STEP 5 (reservado) -->
                <v-stepper-content step="5">
                  <v-row class="mt-2">
                    <v-col cols="12" class="d-flex">
                      <v-btn small outlined color="indigo">{{ editedIndex ? "Editar" : "Guardar" }}</v-btn>
                      <v-btn text class="ml-2" @click="e1 = 4">Regresar</v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

            <div class="text-center ma-2">
              <v-snackbar v-model="snackbar" absolute bottom right timeout="2000" color="red">
                {{ text }}
                <template v-slot:action="{ attrs }">
                  <v-btn color="dark" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
                </template>
              </v-snackbar>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-layout>
        <v-flex>
          <material-card icon="local_shipping" title="Solicitudes creadas " class="px-5 py-3">
            <v-layout>
              <v-flex>
                <v-row>
                  <v-col cols="12">
                    <div class="input-filter">
                      <v-menu offset-y :nudge-width="150">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on" color="primary" class="mb-2">
                            <v-icon>filter_list</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item dense @click="showFilterFolio = true">
                            <v-list-item-title>
                              <span class="texto">Folio</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item dense @click="showFilterEmbarcacion = true">
                            <v-list-item-title>
                              <span class="texto">Embarcación</span>
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="showFilterTipo = true">
                            <v-list-item-title>
                              <span class="texto">Tipo</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item dense @click="showFilterMuelle = true">
                            <v-list-item-title>
                              <span class="texto">Muelle</span>
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item dense @click="showFilterEstatus = true">
                            <v-list-item-title>
                              <span class="texto">Estatus</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item dense @click="showFilterFecha = true">
                            <v-list-item-title>
                              <span class="texto">Fecha</span></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <div class="text-center"></div>
                      <div v-if="arr.length == 0" class="filter-label">
                        <span>Ningun filtro seleccionado...</span>
                      </div>
                      <div v-else class="filter-chips">
                        <v-chip class="ml-2" v-for="(item, index) in arr" :key="index" close close-icon="cancel"
                          @click:close="eliminarFiltro(index)" color="primary" small>
                          {{ item.label }}
                        </v-chip>
                      </div>
                      <v-dialog v-model="showFilterFolio" transition="dialog-bottom-transition" max-width="350">
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por folio</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-text-field v-model="folio_filter" outlined dense prefix="VP-"
                              label="Ingrese el folio de la solicitud"></v-text-field>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('counter')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog v-model="showFilterEmbarcacion" transition="dialog-bottom-transition" max-width="350">
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por embarcación</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete return-object v-model="embarcacion_filter" outlined :items="embarcaciones"
                              dense label="Ingrese la embarcación"></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('embarcacion')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog v-model="showFilterMuelle" transition="dialog-bottom-transition" max-width="350">
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por muelle</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete label="Muelle" :items="muelles" v-model="muelle_filter" hide-details dense
                              outlined></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('muelle')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog v-model="showFilterTipo" transition="dialog-bottom-transition" max-width="350">
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por tipo</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete label="Tipo" :items="[
                              'Prestador de Servicios',
                              'Cesionario',
                              'Contratista',
                              'Armador',
                            ]" v-model="tipo_filter" hide-details dense outlined></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('tipo')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog v-model="showFilterEstatus" transition="dialog-bottom-transition" max-width="350">
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por estatus</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-autocomplete v-if="usuario_log.rol == 'Agencia'" label="Estatus" return-object :items="[
                              { text: 'En proceso', value: '0' },
                              { text: 'Aprobado', value: '2' },
                            ]" hide-details dense v-model="estatus_filter" outlined></v-autocomplete>
                            <v-autocomplete v-else label="Estatus" return-object :items="[
                              { text: 'En proceso', value: '0' },
                              { text: 'Aut-1', value: '1' },
                              { text: 'Aprobado', value: '2' },
                            ]" hide-details dense v-model="estatus_filter" outlined></v-autocomplete>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('estado')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-dialog v-model="showFilterFecha" transition="dialog-bottom-transition" max-width="350">
                        <v-card>
                          <v-toolbar color="primary" dark>Busqueda por fecha</v-toolbar>
                          <v-card-text class="mt-10">
                            <v-text-field v-model="fecha_inicio_filter" type="date" outlined dense
                              label="Inicio"></v-text-field>
                            <v-text-field v-model="fecha_fin_filter" type="date" outlined dense
                              label="Fin"></v-text-field>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="filtroLabelPush('createdAt')">Aplicar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="cambiosGuardia"
              dense
              class="custom-table-header mt-3"
              hide-default-footer
              mobile-breakpoint="600"
            >
              <template v-slot:item.counter="{ item }">
                <td style="font-size: 10px; font-weight: bold">
                  {{ formatFolio(item.counter, item.muelle, item.createdAt) }}
                </td>
              </template>

              <template v-slot:item.embarcacion="{ item }">
                <td style="font-size: 12px; color: gray; font-weight: bold">
                  {{ item.embarcacion.nombre }}
                </td>
              </template>

              <template v-slot:item.muelle="{ item }">
                <td style="font-size: 12px; color: gray; font-weight: bold">
                  {{ item.muelle }}
                </td>
              </template>

              <template v-slot:item.tipo="{ item }">
                <td style="font-size: 12px; color: gray; font-weight: bold">
                  {{ item.tipo }}
                </td>
              </template>

              <template v-slot:item.estado="{ item }">
                <td>
                  <v-chip small class="ma-2" label outlined color="orange" v-if="
                    item.estado == 0 ||
                    (item.estado == 1 && usuario_log.rol == 'Agencia')
                  ">
                    <v-avatar left>
                      <v-icon small>restore</v-icon>
                    </v-avatar>
                    En proceso de autorización
                  </v-chip>

                  <v-chip small class="ma-2" label outlined color="" v-if="
                    item.estado == 1 &&
                    (usuario_log.rol == 'Administrador' || usuario_log.rol == 'Operaciones' || usuario_log.rol == 'OPIP' || usuario_log.rol == 'root')
                  ">
                    <v-avatar left>
                      <v-icon small>restore</v-icon>
                    </v-avatar>
                    Autorizado por el OPIP
                  </v-chip>

                  <v-chip small class="ma-2" color="green" label outlined v-if="item.estado == 2">
                    <v-avatar left>
                      <v-icon small>done</v-icon>
                    </v-avatar>
                    Aprobado
                  </v-chip>

                  <v-chip small class="ma-2" color="black" text-color="white" v-if="item.estado == 4">
                    <v-avatar left>
                      <v-icon small>verified</v-icon>
                    </v-avatar>
                    Servicio realizado
                  </v-chip>

                  <v-tooltip top v-if="item.estado == 5">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip small color="red" label outlined v-bind="attrs" v-on="on" class="ma-2">
                        <v-avatar left>
                          <v-icon small>delete</v-icon>
                        </v-avatar>
                        Cancelado
                      </v-chip>
                    </template>
                    <span>{{ item.motivo_cancelacion }}</span>
                  </v-tooltip>
                </td>
              </template>

              <template v-slot:item.pasajeros="{ item }">
                <td style="font-size: 12px; color: gray; font-weight: bold">
                  {{ item.pasajeros.length }} pasajeros
                </td>
              </template>

              <template v-slot:item.vehiculos="{ item }">
                <td style="font-size: 12px; color: gray; font-weight: bold">
                  {{ item.vehiculos.length }} vehiculos
                </td>
              </template>

              <template v-slot:item.opciones="{ item }">
                <td class="text-right">
                  <v-menu bottom left rounded="lg">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>more_horiz</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item v-if="
                        (item.estado !== '2' && usuario_log.rol == 'root') ||
                        (usuario_log.rol == 'Agencia' &&
                          item.estado != '5' &&
                          item.estado != '2')
                      " @click="editItem(item)" link>
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="generarPdfBackend(item)" link>
                        <v-list-item-title>Imprimir documento</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="usuario_log.rol == 'OPIP' && item.estado == '0'"
                        @click="mostrarDialogAut1(item)" link>
                        <v-list-item-title>Aprobar solicitud</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="usuario_log.rol == 'Operaciones' && item.estado == '1'"
                        @click="mostrarDialogAut2(item)" link>
                        <v-list-item-title>Aprobar solicitud</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.estado == '2'" @click="imprimirPaseAcceso(item)" link>
                        <v-list-item-title>Imprimir pase de acceso</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="mostrarDocumentacion(item)" link>
                        <v-list-item-title>Mostrar documentación</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="
                        (usuario_log.rol == 'Operaciones' || usuario_log.rol == 'OPIP' || usuario_log.rol == 'Agencia' || usuario_log.rol == 'PSP') &&
                        item.estado != 5
                      " @click="mostrarDialogCancel(item)" link>
                        <v-list-item-title>Cancelar solicitud</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
          </material-card>

          <template>
            <div class="text-center mt-3">
              <v-pagination v-model="page" @input="listar()" :length="totalPages" :total-visible="7"></v-pagination>
            </div>
          </template>

        </v-flex>
      </v-layout <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">


    </v-flex>
  </v-layout>
</template>
<script>
import MaterialCard from "../components/MaterialCard.vue";
import axios from "axios";
import jsPDF from "jspdf";
import swal from "sweetalert";
import emailjs from "emailjs-com";
import { required, email, minLength } from "vuelidate/lib/validators";
import { uploadDocumentVp } from "../../helpers/handleUploadsDocument";
import LoadingOverlay from "../components/Loading.vue";
import { generateAccesVehiculos } from "./pdf/pase_acceso_vehiculos";
import { imgEncabezado2 } from "../../helpers/imgBase64.js";
import { apitab } from "../../helpers/logoBase64.js"
import QRCode from "qrcode";
import { generarPdfVP, cancelVP, listarPSPestatus, buscarFolioVehiculosPersonal } from "../../api/endpoints";

import autoTable from "jspdf-autotable";

export default {
  components: {
    MaterialCard,
    LoadingOverlay
  },
  icons: {
    iconfont: "fa4",
  },

  validations: {
    tipo: {
      required,
    },
    dates: {
      required,
    },
    muelle: {
      required,
    },

    embarcacion: {
      required,
    },
    compania: {
      required,
    },
    pasajeros: {
      required,
    },
    detalles: {
      required,
      minLength: minLength(10),
    },

    file3: {
      required,
    },
  },

  data() {
    return {
      //Documentación
      dialogDocumentos: false,
      documentos_vehiculos_vis: [],
      documentos_personal_vis: [],
      pdfLink: null,
      buscarFolio: '',
      //----------
      nombreArchivo: [],
      embarcaciones: [],
      ListaPSP: [],
      showFilterFolio: false,
      showFilterEmbarcacion: false,
      showFilterMuelle: false,
      showFilterEstatus: false,
      showFilterTipo: false,
      showFilterFecha: false,
      folio_filter: "",
      embarcacion_filter: null,
      muelle_filter: "",
      estatus_filter: null,
      tipo_filter: "",
      fecha_inicio_filter: "",
      fecha_fin_filter: "",
      arr: [],
      e1: 1,
      dialogNuevaSolicitud: false,
      text: "",
      snackbar: false,
      dialog: false,
      page: 1,
      dialogAut1: false,
      dialogAut2: false,
      totalPages: 0,
      itemSelected: [],
      usuario_log: [],
      search: "",
      cambiosGuardia: [],
      loading: false,
      headers: [
        { text: "Folio", value: "counter", sortable: false },
        { text: "Embarcación", value: "embarcacion", sortable: false },
        { text: "Procedencia", value: "muelle", sortable: false },
        { text: "Tipo", value: "tipo", sortable: false },
        { text: "Estatus", value: "estado", sortable: false },
        { text: "Pasajeros", value: "pasajeros", sortable: false },
        { text: "Vehículos", value: "vehiculos", sortable: false },
        { text: "Opciones", value: "opciones", sortable: false, align: "right" },
      ],
      editedIndex: false,
      _id: "",
      embarcacion: "",
      muelles: [
        "MUELLE FISCAL",
        "MUELLE PESCADORES FRONTERA",
        "CENTRO DE REPARACIONES NAVALES",
        "ESPADAÑAL",
        "MUELLE PESCADORES CHILTEPEC",
        "SANCHEZ MAGALLANES",
        "MUELLE DE TANQUES",
        "MUELLE COSUGO",
        "MUELLE PRIVADO CARLOS DAVID"
      ],
      muelle: "",
      nombre_completo: "",
      dates: [],
      folioOtraSolicitud: "",
      marca: "",
      agencias: [],
      tipo: "",
      ingreso_mat: false,
      rfc: "",
      retiro_mat: false,
      pasajerosList: [],
      panel: [0, 1, 2, 3, 4],
      extensionManifiesto: [],
      numbersRandomManifiesto: [],
      nombreManifiestos: [],
      compania: "",
      al_servicio_de: "",
      companias: [],
      compania_aseguradora: "",
      nombre: "",
      file3: "",
      agencia2: "",
      tipos: ["Ayudante", "Chofer"],
      tipoServicio: "",
      agenciasUsuario: [],
      cabeceraDetalles: [
        { text: "Borrar", value: "borrar", sortable: false, },
        { text: "Nombre Completo", value: "nombre_completo", sortable: false, },
        { text: "Compañia", value: "compania", sortable: false},
        { text: "Puesto", value: "puesto", sortable: false, },
        { text: "No. de Licencia", value: "licencia", sortable: false, },
      ],
      cabeceraVehiculos: [
        { text: "Borrar", value: "borrar", sortable: false },
        { text: "Marca", value: "marca" },
        { text: "Modelo", value: "tipo" },
        { text: "Color", value: "color" },
        { text: "Placas", value: "placa" },
        { text: "Compañia Aseguradora", value: "compania_aseguradora" },

        { text: "Vigencia de Seguro", value: "vigenciaSeguro" },
      ],

      adjuntos: [
        { text: "Tarjeta de Circulacion", value: "tarjetaCirculacion" },
        { text: "Poliza", value: "poliza" },
      ],

      pasajeros: [],
      vehiculos: [],
      verNuevo: 0,
      usuario: "",
      fecha_solicitud: "",
      imgData:
        "data:image/png;base64,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",
      agencia: "",
      fecha: "",
      counter: "",
      vigencia: "",
      folio: "",
      fecha: "",
      estado: "",
      file3: [],
      file2: [],
      placa: "",
      prueba: [],
      file: "",
      fechaActual: "",
      fechaFinal: "",
      vigenciaSeguro: "",
      ingreso_mat: "",
      retiro_mat: "",
      color: "",
      personal: [],
      vehiculosAdjuntos: [],
      extensionVehiculos: [],
      numbersRandomVehiculos: [],
      nombreVehiculos: [],
      tipoVehiculo: "",
      mostrarAdjuntos: false,
      targetaCirculacion: "",
      poliza: "",
      numbersRandom: [],
      detalles: "",
      valida: 0,
      nombreArchivo2: "",
      extension: [],
      nombreArchivo3: "",
      nombreArchivos: [],
      fecha: null,
      validaMensaje: [],
      aprobacionAmls: "",
      aprobacionApi: "",
      adModal: 0,
      submited: "",
      modal: "",
      date: "",
      on: "",
      comprobanteModal: 0,
      adAccion: 0,
      ListaPSP: [],
      cargo: "",
      adNombre: "",
      adId: "",
      maxSizeInBytes: 20 * 1024 * 1024, // 20 MB
      fileRules: [
        (file2) => this.validateRequired(file2) || "",
        (file2) =>
          this.isTotalFileSizeValid(file2) || "El tamaño total debe ser menor de 20 MB",
      ],
      fileRulesPersonal: [
        (file3) => this.validateRequired(file3) || "",
        (file3) =>
          this.isTotalFileSizeValid(file3) || "El tamaño total debe ser menor de 20 MB",
      ],
      dialogCancell: false,
      motivo_cancell: "",
      isFormCancellValid: false,
      rules: {
        required: (value) => !!value || "Este campo es requerido",
      },
      company_logo: {
        w: 460,
        h: 60,
      },
    };
  },
  computed: {
    formTitle() {
      return !this.editedIndex ? "Nueva Solicitud" : "Editar Solicitud";
    },

    dateRangeText() {
      return this.dates.join(" al ");
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    compania(val) {
      if (this.tipo === 'Proveedor') {
        this.pasajeros.forEach(p => { p.compania = val; });
      }
    },
  },

  created() {
    this.listar();
    this.selectEmbarcaciones();
    this.listarAgencia(this.$store.state.usuario.agencia);
    //this.selectCompanias();
    this.usuario_log = this.$store.state.usuario;
    this.loadPspList();
    //this.emailIn();
  },

  methods: {

    validateRequired(file2) {
      return file2 && file2.length > 0; // Verifica si hay al menos un archivo seleccionado
    },
    isTotalFileSizeValid(file2) {
      if (!file2 || file2.length === 0) return true; // No mostrar error si no hay archivos

      const totalSize = file2.reduce((acc, file2) => acc + file2.size, 0); // Sumar los tamaños de todos los archivos
      return totalSize <= this.maxSizeInBytes; // Comparar con el tamaño máximo permitido
    },
    // Verifica el tamaño total y limpia la selección si supera el límite
    validateFileSize(file2) {
      if (file2 && !this.isTotalFileSizeValid(file2)) {
        this.file2 = []; // Limpia la selección de archivos
        this.$emit("input", []); // Limpia los archivos seleccionados
        this.$notify({
          title: "!Alerta!",
          text: "Los archivos adjuntos deben pesar menos de 20mb",
          type: "warning",
        });
      }
    },

    validateRequiredPersonal(file3) {
      return file3 && file3.length > 0; // Verifica si hay al menos un archivo seleccionado
    },
    isTotalFileSizeValidPersonal(file3) {
      if (!file3 || file3.length === 0) return true; // No mostrar error si no hay archivos

      const totalSize = file3.reduce((acc, file3) => acc + file3.size, 0); // Sumar los tamaños de todos los archivos
      return totalSize <= this.maxSizeInBytes; // Comparar con el tamaño máximo permitido
    },
    // Verifica el tamaño total y limpia la selección si supera el límite
    validateFileSizePersonal(file3) {
      if (file3 && !this.isTotalFileSizeValidPersonal(file3)) {
        this.file3 = []; // Limpia la selección de archivos
        this.$emit("input", []); // Limpia los archivos seleccionados
        this.$notify({
          title: "!Alerta!",
          text: "Los archivos adjuntos deben pesar menos de 20mb",
          type: "warning",
        });
      }
    },
    imprimir() {
      var objeto = document.getElementById("solicitudGuardia"); //obtenemos el objeto a imprimir
      var ventana = window.open("", "_blank"); //abrimos una ventana vacía nueva
      ventana.document.write(objeto.innerHTML); //imprimimos el HTML del objeto en la nueva ventana
      ventana.document.close(); //cerramos el documento
      ventana.print(); //imprimimos la ventana
      ventana.close(); //cerramos la ventana
    },

    mostrarComprobante(item) {
      console.log(item)
      this.limpiar();
      this.fecha = item.fecha;
      this.counter = item.counter;
      this.aprobacionAmls = item.aprobacionAmls;
      this.detalles = item.detalles;
      this.estado = item.estado;
      this.aprobacionApi = item.aprobacionApi;
      this.usuario = item.usuario;
      this.muelle = item.muelle;
      this.nombre_completo = item.usuario[0].nombre;
      this.cargo = item.usuario[0].cargo;
      (this.ingreso_mat = item.ingreso_mat), (this.retiro_mat = item.retiro_mat);
      //this.listarAgencia(item.agencia);
      var solic_fec = item.fecha;
      var fecha = new Date();
      var vigencia = new Date(item.fecha);
      this.fechaActual = new Date();
      this.fechaFinal = vigencia;
      this.tipo = item.tipo;
      this.compania = item.compania;
      this.al_servicio_de = item.al_servicio_de;
      var options = { year: "numeric", month: "long", day: "numeric" };
      var fec = new Date(solic_fec);
      this.fecha_solicitud = item.fecha.join(" al ");
      this.fecha = fecha.toLocaleDateString("es-ES", options);
      this.embarcacion = item.embarcacion;
      this._id = item._id;
      this.pasajeros = item.pasajeros
      this.vehiculos = item.vehiculos
      vigencia.setDate(vigencia.getDate() + 3);
      this.vigencia = vigencia;
      this.agencia = item.agencia;
      //this.listarDetalles(item._id);
      //this.listarDetallesVehiculos(item._id);
      this.comprobanteModal = 1;
      this.generarPDF()
    },
    ocultarComprobante(item) {
      this.comprobanteModal = 0;
    },

    mostrarNuevo() {
      this.dialogNuevaSolicitud = true;
      this.editedIndex = false;
      this.e1 = 1; this.limpiar();
    },
    ocultarNuevo() {
      this.dialogNuevaSolicitud = false;
      this.editedIndex = false;
      this.e1 = 1;
      this.limpiar();
    },

    mostrarDatosAgencia() {
      this.listarAgencia(this.agencia);
    },

    eliminarPasajero(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    eliminarVehiculo(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    emailIn() {
      emailjs.init("user_QA8qMBuyHCQIHTgR0AsPx");
    },

    enviar(fecha, embarcacion, muelle, detalles, usuario, status, correo) {
      var template_params = {
        fecha: fecha,
        embarcacion: embarcacion,
        muelle: muelle,
        detalles: detalles,
        usuario: usuario,
        status: status,
        correo: correo,
      };

      emailjs.send("gmail", "vehiculopersonal", template_params).then(
        function (response) {
          if (response.text === "OK") {
          }
          console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
        },
        function (err) {
          alert("Ocurrió un problema al enviar el correo");
          console.log("FAILED. error=", err);
        }
      );
    },

    listarEmbarcacion(fecha, embar, muelle, detalles, usuario, correo) {
      let header = { Token: this.$store.state.token };
      let me = this;
      let embarcacion;

      let configuracion = { headers: header };
      axios
        .get("embarcacion/query?_id=" + embar, configuracion)
        .then(function (response) {
          embarcacion = response.data;
          var fechaLocal;
          status = "en proceso";

          me.enviar(fecha, embarcacion, muelle, detalles, usuario, status, correo);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCompanias() {
      let me = this;
      let companiaArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("companias/list?agencia=" + this.$store.state.usuario.agencia, configuracion)
        .then((response) => {
          companiaArray = response.data;
          companiaArray.map(function (x) {
            me.companias.push({ text: x.razon_social, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarAgencia(id) {
      let me = this;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .get("agencia/query?_id=" + id, configuracion)
        .then(function (response) {
          me.agenciasUsuario = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    obtenerDatosPorFolio() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "vehiculoPersonal/queryFolio?counter=" + this.folioOtraSolicitud,
          configuracion
        )
        .then(function (response) {
          if (response.data.agencia == me.$store.state.usuario.agencia) {
            me.llenarFolio(response.data);
          } else {
            swal("Error", "Folio no autorizado", "error");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadPspList() {
      try {
        const data = await listarPSPestatus();
        this.ListaPSP = data.lista_psp.map((psp) => ({
          label:
            psp.razon_social +
            (psp.estatus !== "Al corriente" ? ` - ${psp.estatus}` : ""),
          value: psp.razon_social,
          estatus: psp.estatus,
          razon_social: psp.razon_social,
        }));
      } catch (err) {
        console.error(err);
        this.ListaPSP = [];
      }
    },

    selectEmbarcaciones() {
      let me = this;
      let embarcacionArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("embarcacion/listActivos", configuracion)
        .then((response) => {
          embarcacionArray = response.data;
          embarcacionArray.map(function (x) {
            me.embarcaciones.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectAgencias() {
      let me = this;
      let agencaiArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("agencia/list", configuracion)
        .then((response) => {
          agencaiArray = response.data;
          agencaiArray.map(function (x) {
            me.agencias.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      if (!this.embarcacion) {
        this.validaMensaje.push("La embarcación es obligatorio");
      }

      if (!this.muelle) {
        this.validaMensaje.push("El muelle es obligatoria");
      }

      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    agregarDetalle() {
      this.pasajeros.push({
        nombre_completo: "",
        compania: this.tipo === 'Proveedor' ? this.compania : "",
        puesto: "",
        licencia: "",
      });
    },

    async generarPDF() {
      var doc = new jsPDF("p", "pt", "a4");
      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      var startX = 40;
      var startY = 10;

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Solicitud de Entrada", pageWidth / 2, 100, { align: "center" });
      doc.text("VP-" + this.counter, pageWidth / 2, 110, { align: "center" });
      doc.addImage(
        imgEncabezado2,
        "JPEG",
        startX,
        (startY += 20),
        this.company_logo.w,
        this.company_logo.h, undefined, "FAST"
      );

      doc.addImage(
        apitab,
        "JPEG",
        startX + 380,
        (startY += 8),
        80,
        50
      );
      doc.setFont("helvetica", "normal");

      //QR
      const qrText = this._id;
      const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 228 });
      if (qrCodeDataURL) {
        const qrWidth = 60; // Ancho del QR
        const qrHeight = 60; // Altura del QR
        const qrXPosition = 510; // Posiciona el QR en el centro horizontal
        const qrYPosition = 30; // Posición vertical más baja

        doc.addImage(qrCodeDataURL, "PNG", qrXPosition, qrYPosition, qrWidth, qrHeight);
      } else {
        console.error("Error al generar el código QR");
      }

      //doc.setFontType("normal");
      doc.setFontSize(8);

      doc.text("Frontera, Tab. a: " + this.fecha, 365, 125);
      //doc.setFontType("bold");
      // if (this.solicitud) {
      //   doc.text("Solicitud de " + this.solicitud, 365, 175);
      // }
      //doc.setFontType("normal");
      doc.setFontSize(8);
      doc.text(
        "De conformidad y en cumplimiento a lo estipulado en las Reglas de Operación de la APITAB en su capitulo IV.- Acceso y vialidades del Puerto ",
        40,
        155,
        { align: "justify" }
      );
      doc.text(
        "Regla 19, 20, 21 y 22 y Código Internacional de Protección a Buques e Instalaciones Portuarias.",
        40,
        165,
        { align: "justify" }
      );
      doc.text(
        "Solicito la ENTRADA a las areas del recinto portuario concesionadas a la administracion portuaria integral de Tabasco S.A. de C.V con Fecha",
        40,
        175,
        { align: "justify" }
      );
      doc.text(
        this.fecha_solicitud +
        " del personal y vehiculos que a continuacion se enlistan.",
        40,
        185,
        { align: "justify" }
      );

      //Datos de Agencia

      //      doc.setFontType("normal");
      doc.text("Nombre del Solicitante", 40, 210); // Restar 40 a 250
      doc.line(170, 213, 530, 213); // Restar 40 a 253
      doc.text("Cargo", 40, 225); // Restar 40 a 265
      doc.line(170, 228, 530, 228); // Restar 40 a 268
      doc.text("Agencia Naviera", 40, 240); // Restar 40 a 280
      doc.line(170, 243, 530, 243); // Restar 40 a 283
      doc.text(this.nombre_completo, 180, 210);

      //
      if (this.usuario[0].cargo == null) {
        doc.text(".", 180, 225); // Restar 40 a 265
      } else {
        doc.text(this.usuario[0].cargo, 180, 225);
      }
      doc.text(this.agencia.nombre, 180, 240);



      doc.text("Contratista", 40, 260); // Restar 40 a 300
      doc.text("Armador", 180, 260); // Restar 40 a 300
      doc.text("Prestador de Servicios", 290, 260); // Restar 40 a 300
      doc.text("Cesionario", 430, 260); // Restar 40 a 300

      if (this.tipo == "Contratista") {
        doc.rect(130, 252, 10, 10, "F"); // Restar 40 a 292
        doc.rect(250, 252, 10, 10); // Restar 40 a 292
        doc.rect(390, 252, 10, 10); // Restar 40 a 292
        doc.rect(500, 252, 10, 10); // Restar 40 a 292
      } else if (this.tipo == "Armador") {
        doc.rect(130, 252, 10, 10); // Restar 40 a 292
        doc.rect(250, 252, 10, 10, "F"); // Restar 40 a 292
        doc.rect(390, 252, 10, 10); // Restar 40 a 292
        doc.rect(500, 252, 10, 10); // Restar 40 a 292
      }
      if (this.tipo == "Prestador de Servicios") {
        doc.rect(130, 252, 10, 10); // Restar 40 a 292
        doc.rect(250, 252, 10, 10); // Restar 40 a 292
        doc.rect(390, 252, 10, 10, "F"); // Restar 40 a 292
        doc.rect(500, 252, 10, 10); // Restar 40 a 292
      } else if (this.tipo == "Cesionario") {
        doc.rect(130, 252, 10, 10); // Restar 40 a 292
        doc.rect(250, 252, 10, 10); // Restar 40 a 292
        doc.rect(390, 252, 10, 10); // Restar 40 a 292
        doc.rect(500, 252, 10, 10, "F"); // Restar 40 a 292
      }

      //Caracteristicas de la Embarcacion
      doc.setFillColor(196, 196, 196);
      doc.rect(40, 270, 495, 10, "F"); // Restar 40 a 310
      //doc.setFontType("bold");
      doc.text("Caracteristicas de la Embarcación", 42, 278); // Restar 40 a 318
      //doc.setFontType("normal");
      doc.text("Nombre de la Embarcación", 40, 300); // Restar 40 a 340
      doc.text(this.embarcacion.nombre, 173, 300); // Restar 40 a 340
      doc.line(170, 303, 530, 303); // Restar 40 a 343
      doc.text("Al servicio de la compañia", 40, 315); // Restar 40 a 355
      doc.text(this.compania, 173, 315); // Restar 40 a 355
      doc.line(170, 318, 530, 318); // Restar 40 a 358
      doc.text("Tipo", 40, 330); // Restar 40 a 370
      doc.text(this.embarcacion.tipo, 63, 330); // Restar 40 a 370
      doc.line(60, 333, 140, 333); // Restar 40 a 373
      doc.text("Bandera", 150, 330); // Restar 40 a 370
      doc.text(this.embarcacion.bandera, 188, 330); // Restar 40 a 370
      doc.line(185, 333, 265, 333); // Restar 40 a 373
      doc.text("T.R.B.", 275, 330); // Restar 40 a 370
      doc.text(this.embarcacion.tbr.toString(), 303, 330); // Restar 40 a 370
      doc.line(300, 333, 350, 333); // Restar 40 a 373
      doc.text("Eslora", 360, 330); // Restar 40 a 370
      doc.text(this.embarcacion.eslora.toString(), 393, 330); // Restar 40 a 370
      doc.line(390, 333, 440, 333); // Restar 40 a 373
      doc.text("Manga", 450, 330); // Restar 40 a 370
      doc.text(this.embarcacion.manga.toString(), 483, 330); // Restar 40 a 370
      doc.line(480, 333, 530, 333); // Restar 40 a 373

      doc.setFillColor(196, 196, 196);
      doc.rect(39, 350, 516, 10, "F");

      // Tabla de Pasajeros
      var columns = [
        { title: "Nombre", dataKey: "nombre_completo" },
        { title: "Compañia", dataKey: "compania" },
        { title: "Puesto", dataKey: "puesto" },
        { title: "No. de Licencia", dataKey: "licencia" },
      ];

      var rows = [];

      this.pasajeros.map((x) => {
        rows.push({
          nombre_completo: x.nombre_completo,
          compania: x.compania,
          puesto: x.puesto,
          licencia: x.licencia,
        });
      });





      autoTable(doc, {
        theme: "grid",
        columns: columns,
        body: rows,
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [12, 1, 1],
          fontSize: 8,
        },
        styles: {
          overflow: "linebreak",
          lineWidth: 1,
          lineColor: [0, 0, 0],
          fontSize: 8,
        },
        startY: 360, // Restar 40 a 400
        showHead: "firstPage",
      });



      let finalY = doc.autoTable.previous.finalY || 400;

      var columnsVehiculo = [
        { title: "Marca", dataKey: "marca" },
        { title: "Modelo", dataKey: "tipo" },
        { title: "Color", dataKey: "color" },
        { title: "Placas", dataKey: "placa" },
        { title: "Compañia de aseguradora", dataKey: "compania_aseguradora" },
        { title: "Vigencia de seguro", dataKey: "vigenciaSeguro" },
      ];

      var rowsVehiculo = [];

      this.vehiculos.map((x) => {
        rowsVehiculo.push({
          marca: x.marca,
          tipo: x.tipo,
          color: x.color,
          placa: x.placa,
          compania_aseguradora: x.compania_aseguradora,
          vigenciaSeguro: x.vigenciaSeguro,
        });
      });

      doc.autoTable(columnsVehiculo, rowsVehiculo, {
        theme: "grid",
        headerStyles: {
          fillColor: [255, 255, 255],
          textColor: [12, 1, 1],
          fontSize: 8,
        },
        didDrawPage: function (data) {
          if (data.pageNumber === 1) {
            doc.setFontSize(8);
            doc.setFillColor(196, 196, 196);
            doc.rect(data.settings.margin.left, finalY + 10, 516, 10, "F");
            doc.text('Lista de Vehiculos', data.settings.margin.left, finalY + 18); // Ajustar posición en función de la tabla anterior
          } else {
            doc.setFontSize(8);
            doc.setFillColor(196, 196, 196);
            doc.rect(data.settings.margin.left, data.settings.margin.top - 10, 516, 10, "F"); // Rectángulo de fondo
            doc.text('Lista de Vehículos', data.settings.margin.left, data.settings.margin.top - 3); // Texto del título   
          }

        },
        styles: {
          overflow: "linebreak",
          fontSize: 8,
          lineWidth: 1,
          lineColor: [0, 0, 0],
        },
        startY: finalY + 20, // Comenzar la tabla justo debajo de la primera
      });


      let finalYSecondTable = doc.lastAutoTable.finalY + 20 || finalYFirstTable + 30;
      const margin = 20; // Margen inferior deseado
      const pageHeight2 = 647; // Altura de una hoja A4 en mm
      const currentY = finalYSecondTable + 20; // Ajuste del Y actual (10 de título + 20 de la rectángulo)

      if (currentY > pageHeight2 - margin) {
        doc.addPage(); // Agregar nueva página
        finalYSecondTable = 40; // Reiniciar Y a una posición de inicio deseada en la nueva página
      }

      // A partir de aquí, puedes continuar dibujando el contenido
      doc.text("Ingreso de material o equipo", 40, finalYSecondTable + 10);
      doc.text("Retiro de material o equipo", 290, finalYSecondTable + 10);

      if (this.ingreso_mat) {
        doc.rect(200, finalYSecondTable + 3, 10, 10, "F");
      } else {
        doc.rect(200, finalYSecondTable + 3, 10, 10);
      }

      if (this.retiro_mat) {
        doc.rect(450, finalYSecondTable + 3, 10, 10, "F");
      } else {
        doc.rect(450, finalYSecondTable + 3, 10, 10);
      }

      doc.setFillColor(196, 196, 196);
      doc.rect(40, finalYSecondTable + 20, 516, 10, "F");
      doc.text("Motivo de la visita", 42, finalYSecondTable + 27);
      doc.text(this.detalles, 46, finalYSecondTable + 45);
      doc.rect(40, finalYSecondTable + 30, 516, 40);

      const pdfOutput = doc.output("blob");

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfOutput);

      // Open the PDF preview in a new window
      window.open(pdfUrl, "_blank");
    },

    agregarVehiculos() {
      this.vehiculos.push({
        marca: "",
        placa: "",
        vigenciaSeguro: "",
        color: "",
        tipoVehiculo: "",
        targetaCirculacion: "",
        poliza: "",
        compania_aseguradora: "",
      });
    },

    limpiar() {
      this._id = "";
      this.muelle = "";
      this.fecha;
      (this.usuario = ""),
        (this.embarcacion = ""),
        (this.vehiculos = ""),
        (this.fecha = ""),
        (this.nombreArchivos = []);
      (this.pasajeros = []),
        (this.vehiculos = []),
        (this.nombreArchivo = ""),
        (this.nombreArchivo2 = ""),
        (this.nombreArchivo3 = ""),
        (this.valida = 0),
        (this.validaMensaje = []),
        (this.editedIndex = false);
        this.buscarFolio = "";
        this.compania = ""; 
        this.al_servicio_de = "";
        this.dates = [];
        this.date = ""; 
        this.dateRangeText = ""; 

    },

    handleFileUpload(e) { },
    handleFileUploadPersonal(e) {
      this.file3 = e;
    },
    handleFileUploadManifiesto(e) {
      this.file = e;
    },
    handleFileUploadVehiculos(e) {
      this.file2 = e;
    },

    async guardar() {
      this.loading = true
      let me = this;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      let personal;
      let manifiestos;
      let vehiculosAdjuntos;

      if (this.retiro_mat == "" && this.ingreso_mat == "") {
        this.retiro_mat = false;
        this.ingreso_mat = false;
      }
      if (this.retiro_mat == "") {
        this.retiro_mat = false;
      }
      if (this.ingreso_mat == "") {
        this.ingreso_mat = false;
      }

      let manifiestos_links = [];
      let vehiculos_links = [];
      let personal_links = [];
      if (this.editedIndex) {
        if (me.file) {
          manifiestos = me.file;
          const uploadPromises = manifiestos.map((adjunto) => uploadDocumentVp(adjunto));
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => manifiestos_links.push(url));
          console.log("FILE1");

          console.log(urls);

        }
        if (me.file2) {
          vehiculosAdjuntos = me.file2;

          const uploadPromises = vehiculosAdjuntos.map((adjunto) =>
            uploadDocumentVp(adjunto)
          );
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => vehiculos_links.push(url));
          console.log("FILE2");
          console.log(urls);
        }
        if (me.file3) {
          personal = me.file3;

          const uploadPromises = personal.map((adjunto) => uploadDocumentVp(adjunto));
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => personal_links.push(url));
          console.log("FILE3");
          console.log(urls);

        }

        axios
          .put(
            "vehiculoPersonal/actualizar",
            {
              _id: this._id,
              embarcacion: this.embarcacion,
              muelle: this.muelle,
              pasajeros: this.pasajeros,
              fecha: this.dates,
              vehiculos: this.vehiculos,
              manifiesto: manifiestos_links,
              vehiculos_adj: vehiculos_links,
              personal_adj: personal_links,
              tipo: this.tipo,
              retiro_mat: this.retiro_mat,
              ingreso_mat: this.ingreso_mat,
              compania: this.compania,
              al_servicio_de: this.al_servicio_de,
              detalles: this.detalles,
              agencia: this.agenciasUsuario._id,
              inicioPrograma: new Date(this.dates[0]),
              terminoPrograma: this.dates[1] ? new Date(this.dates[1]) : new Date(this.dates[0]),
            },
            configuracion
          )
          .then(function (response) {
            swal(
              "Nueva Solicitud de Acceso Actualizada",
              "Solicitud de acceso a vehiculos y personal actualizada exitosamente",
              "success"
            );

            me.limpiar();
            me.ocultarNuevo();
            me.listar();
          })
          .catch(function (error) {
            me.close();
            swal(
              "Error",
              "Error al ingresar la solicitud, verifica los datos ingresados" + error,
              "error"
            );
          }).finally(() => {
            this.loading = false
          });
      } else {
        if (me.file) {
          manifiestos = me.file;
          const uploadPromises = manifiestos.map((adjunto) => uploadDocumentVp(adjunto));
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => manifiestos_links.push(url));
        }
        if (me.file2) {
          vehiculosAdjuntos = me.file2;

          const uploadPromises = vehiculosAdjuntos.map((adjunto) =>
            uploadDocumentVp(adjunto)
          );
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => vehiculos_links.push(url));
        }
        if (me.file3) {
          personal = me.file3;

          const uploadPromises = personal.map((adjunto) => uploadDocumentVp(adjunto));
          const urls = await Promise.all(uploadPromises);
          urls.forEach((url) => personal_links.push(url));
        }


        axios
          .post(
            "vehiculoPersonal/add",
            {
              embarcacion: this.embarcacion,
              usuario: this.$store.state.usuario._id,
              muelle: this.muelle,
              fecha: this.dates,
              pasajeros: this.pasajeros,
              vehiculos: this.vehiculos,
              manifiesto: manifiestos_links,
              vehiculos_adj: vehiculos_links,
              personal_adj: personal_links,
              detalles: this.detalles,
              tipo: this.tipo,
              agencia: this.agenciasUsuario._id,
              retiro_mat: this.retiro_mat,
              ingreso_mat: this.ingreso_mat,
              compania: this.compania,
              al_servicio_de: this.al_servicio_de,
              inicioPrograma: new Date(this.dates[0]),
              terminoPrograma: this.dates[1] ? new Date(this.dates[1]) : new Date(this.dates[0]), // Si dates[1] es null, usa dates[0]
            },
            configuracion
          )
          .then(function (response) {
            swal(
              "Nueva Solicitud de Acceso Ingresada" + " Folio VP" + response.data.counter,
              "Solicitud de acceso a vehiculos y personal ingresada exitosamente",
              "success"
            );

            me.limpiar();
            me.ocultarNuevo();
            me.close();
            me.listar();
          })
          .catch(function (error) {
            console.log(error)
            me.$notify({
              title: "¡Éxito!",
              text: "La operación se completo con éxito",
              type: "success",
            });
          }).finally(() => {
            this.loading = false
          });
      }
    },

    descargarManifiesto(manifiesto) {
      window.open(manifiesto, "_blank");
    },
    descargarVehiculos(vehiculos_adj) {
      window.open(vehiculos_adj, "_blank");
    },
    descargarPersonal(soporte) {
      window.open(soporte, "_blank");
    },
    listar() {
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      this.loading = true
      let me = this;
      axios
        .post(
          "vehiculoPersonal/list?page=" + this.page, this.arr,
          configuracion
        )
        .then(function (response) {
          me.cambiosGuardia = response.data.reg;
          me.totalPages = response.data.totalPaginas;

        })

        .catch(function (error) {
          console.log(error);
        }).finally(() => {
          this.loading = false
        });
    },

    listarDetalles(id) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("vehiculoPersonal/query?_id=" + id, configuracion)
        .then(function (response) {
          me.pasajeros = response.data.pasajeros;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarDetallesVehiculos(id) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("vehiculoPersonal/query?_id=" + id, configuracion)
        .then(function (response) {
          me.vehiculos = response.data.vehiculos;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    finalizarServicio() {
      let me = this;
      let header = { Token: this.$store.state.token };

      let configuracion = { headers: header };
      axios
        .put("vehiculoPersonal/aprobarApi", { _id: this._id }, configuracion)

        .then(function (response) {
          swal(
            "Solicitud Finalizada",
            "La solicitud se ha guardado como realizada",
            "success"
          );
          me.ocultarComprobante();
          (me.adModal = 0),
            (me.adAccion = 0),
            (me.adNombre = ""),
            (me.adId = ""),
            me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    verGuardia(item) {
      this.limpiar();
      this.fecha = item.fecha;
      this.folio = item.folio;
      this.muelle = item.muelle;
      this.detalles = item.detalles;
      this.agencia = item.agencia._id;
      this.embarcacion = item.embarcacion._id;
      this.listarDetalles(item._id);
      this.verNuevo = 1;
    },

    editItem(item) {
      this.limpiar();

      this.agencia = item.agencia;
      //  this.listarAgencia(item.agencia);

      this.muelle = item.muelle;
      this.embarcacion = item.embarcacion._id;
      //  this.listarDetalles(item._id);
      //  this.listarDetallesVehiculos(item._id);
      this.tipo = item.tipo;
      this.compania = item.compania;
      this.al_servicio_de = item.al_servicio_de;
      this.retiro_mat = item.retiro_mat;
      this.ingreso_mat = item.ingreso_mat;
      this.pasajeros = item.pasajeros
      this.vehiculos = item.vehiculos
      this.verNuevo = 1;
      this._id = item._id;
      this.folio = item.folio;

      this.dates = item.fecha;
      this.nombreArchivo = item.personal_adj;
      this.nombreArchivo2 = item.vehiculos_adj;
      this.detalles = item.detalles;
      this.editedIndex = true;
      this.dialog = false;
      this.dialogNuevaSolicitud = true
    },

    llenarFolio(item) {
      this.limpiar();

      this.agencia = item.agencia;
      this.listarAgencia(item.agencia);

      this.muelle = item.muelle;
      this.embarcacion = item.embarcacion._id;
      this.listarDetalles(item._id);
      this.listarDetallesVehiculos(item._id);
      this.tipo = item.tipo;
      this.compania = item.compania;
      this.al_servicio_de = item.al_servicio_de;
      this.retiro_mat = item.retiro_mat;
      this.ingreso_mat = item.ingreso_mat;

      this._id = item._id;
      this.folio = item.folio;

      this.dates = item.fecha;
      this.nombreArchivo = item.manifiesto;
      this.nombreArchivo2 = item.vehiculos_adj;
      this.detalles = item.detalles;
    },

    download(item) {
      axios
        .get("vehiculoPersonal/getAccesoManifiesto/" + item.manifiesto, {
          responseType: "arraybuffer",
        })
        .then(function (response) {
          let blob = new Blob([response.data], { type: "content-type" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "manifiesto.pdf";
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    downloadPersonal(item) {
      axios
        .get("vehiculoPersonal/getAccesoPersonal/" + item.personal_adj, {
          responseType: "arraybuffer",
        })
        .then(function (response) {
          let blob = new Blob([response.data], { type: "content-type" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "personal.pdf";
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    downloadVehiculo(item) {
      axios
        .get("vehiculoPersonal/getAccesoVehiculo/" + item.vehiculos_adj, {
          responseType: "arraybuffer",
        })
        .then(function (response) {
          let blob = new Blob([response.data], { type: "content-type" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "personal.pdf";
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item, folio) {
      console.log(this._id);
      this.adModal = 1;
      this.adNombre = item.folio;
      this.adId = folio.counter;
      this._id = item._id;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else if (accion == 3) {
        this.adAccion = 3;
      } else if (accion == 4) {
        this.adAccion = 4;
      } else {
        this.adMmodal = 0;
      }
    },
    activar() {
      let me = this;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      this.loading = true
      axios
        .put(
          "vehiculoPersonal/activate",
          { _id: this.itemSelected._id, aprobacionAmls: this.$store.state.usuario.nombre },
          configuracion
        )
        .then(function (response) {

          me.comprobanteModal = 0;
          swal("Solicitud Aprobada", "Solicitud Aprobada con exito", "success");
          me.dialogAut1 = false
          me.itemSelected = []
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        }).finally(() => {
          this.loading = false
        });
    },

    desactivar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "vehiculoPersonal/deactivate",
          {
            _id: this._id,
            aprobacionAmls: this.$store.state.usuario.nombre,
            motivo_cancelacion: this.motivo_cancelacion,
          },
          configuracion
        )
        .then(function (response) {
          me.comprobanteModal = 0;
          swal("Solicitud Cancelada", "Solicitud cancelada con exito", "success");
          (me.adModal = 0),
            (me.adAccion = 0),
            (me.adNombre = ""),
            (me.adId = ""),
            me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    mostrarDialogAut1(item) {
      this.itemSelected = item;
      this.dialogAut1 = true;
    },
    mostrarDialogAut2(item) {
      this.itemSelected = item;
      this.dialogAut2 = true;
    },


    checkDataStepper(step) {
      const stepsFields = {
        1: [this.dateRangeText, this.muelle, this.tipo, this.embarcacion, this.compania],
        2: [this.pasajeros.length > 0],
        3: [this.vehiculos.length > 0],
        4: [this.file2, this.file3, this.detalles],
      };

      const requiredFields = stepsFields[step];
      const isAnyFieldMissing = requiredFields.some((field) => !field);

      if (isAnyFieldMissing) {
        this.text = "Todos los campos son obligatorios";
        this.snackbar = true;
      } else if (this.e1 == 4) {
        this.guardar()
      } else {
        this.e1 = step + 1; // Avanza al siguiente paso
      }
    },


    descargarAdjuntos(adjuntos) {
      window.open(adjuntos, "_blank");
    },

    autorizarOpib() {
      let me = this;
      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .put(
          "vehiculoPersonal/autorizar_opib",
          {
            _id: this.itemSelected._id,
          },
          configuracion
        )

        .then(function (response) {
          swal(
            "Solicitud Confirmada",
            "Solicitud confirmada con exito",
            "success"
          );
          me.dialogAut2 = false;
          me.itemSelected = [];

          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },


    eliminarAdjuntoPersonal(arr, item) {
      this.eliminarAdjuntoEndpointPersonal(item);

      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    eliminarAdjuntoVehiculo(arr, item) {
      this.eliminarAdjuntoEndpointVehiculo(item);

      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    eliminarAdjuntoEndpointVehiculo(file) {
      let me = this;
      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .put(
          "vehiculoPersonal/eliminar_adj_vehiculo",
          {
            _id: this._id,
            url: file,
          },
          configuracion
        )

        .then(function (response) { })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    eliminarAdjuntoEndpointPersonal(file) {
      let me = this;
      this.loading = true;
      const configuracion = {
        headers: {
          Authorization: `Bearer ` + this.$store.state.token,
        },
      };
      axios
        .put(
          "vehiculoPersonal/eliminar_adj_personal",
          {
            _id: this._id,
            url: file,
          },
          configuracion
        )

        .then(function (response) { })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },


    imprimirPaseAcceso(item) {
      const datos = {
        embarcacion: item.embarcacion.nombre,
        muelle: item.muelle,
        folio: item.counter,
        _id: item._id,
        agencia: item.agencia.nombre,
        createdAt: item.createdAt
      };
      generateAccesVehiculos(datos)
    },

    close() {
      this.dialog = false;
    },

    filtroLabelPush(tipo) {
      if (tipo == "counter") {
        let existe = this.arr.findIndex((e) => e.field == "counter");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "counter",
          value: this.folio_filter,
          label: "Folio : " + this.folio_filter,
          collection: "rf",
        });
      } else if (tipo == "embarcacion") {
        let existe = this.arr.findIndex((e) => e.field == "embarcacion");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "embarcacion",
          value: this.embarcacion_filter.value,
          label: "Embarcación: " + this.embarcacion_filter.text,
          collection: "embarcacion",
        });
      } else if (tipo == "tipo") {
        let existe = this.arr.findIndex((e) => e.field == "tipo");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "tipo",
          value: this.tipo_filter,
          label: "Tipo : " + this.tipo_filter,
          collection: "rf",
        });
      } else if (tipo == "muelle") {
        let existe = this.arr.findIndex((e) => e.field == "muelle");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "muelle",
          value: this.muelle_filter,
          label: "Muelle : " + this.muelle_filter,
          collection: "rf",
        });
      } else if (tipo == "estado") {
        let existe = this.arr.findIndex((e) => e.field == "estado");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "estado",
          value: this.estatus_filter.value,
          label: "Estatus : " + this.estatus_filter.text,
          collection: "rf",
        });
      } else if (tipo == "createdAt") {
        const fecha_inicio = new Date(this.fecha_inicio_filter);
        const fecha_fin = new Date(this.fecha_fin_filter);
        let existe = this.arr.findIndex((e) => e.field == "createdAt");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "createdAt",
          value: {
            $gte: fecha_inicio,
            $lte: fecha_fin,
          },
          label: "Entre : " + this.fecha_inicio_filter + " y " + this.fecha_fin_filter,
          collection: "rf",
        });
      }

      this.showFilterFolio = false;
      this.showFilterEmbarcacion = false;
      this.showFilterProcedencia = false;
      this.showFilterMuelle = false;
      this.showFilterEstatus = false;
      this.showFilterFecha = false;
      this.showFilterTipo = false;
      this.listar();
      // this.showFilterFecha = false;
      // this.showFilterOperador = false;
      // this.showFilterTipoUnidad = false;
    },
    eliminarFiltro(index) {
      this.arr.splice(index, 1);
      this.listar();
    },

    mostrarDocumentacion(item) {
      this.dialogDocumentos = true;
      this.documentos_vehiculos_vis = item.vehiculos_adj;
      this.documentos_personal_vis = item.personal_adj;
      this.pdfLink = null;
    },
    viewPdf(url) {
      this.pdfLink = url;
    },

    async generarPdfBackend(item) {
      this.loading = true;

      await generarPdfVP(item)
        .then((e) => {
          const base64PDF = e.data;
          const blob = this.base64ToBlob(base64PDF, "application/pdf");
          const url = URL.createObjectURL(blob);
          // Abre el PDF en una nueva ventana
          window.open(url, `_blank`);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // TODO: Crea una funcion para realizar el fetch y buscar el folio si encuentra el folio rellenar todos los inputs con la informacion que trae la consulta de lo contrario manda un mensaje de alerta con el texto de folio no encontrado


    mostrarDialogCancel(item) {
      if (!item.pasajeros || !Array.isArray(item.pasajeros)) {
        return false;
      }

      // Verifica si algún pasajero tiene entradas en su access_logs
      const exist_access = item.pasajeros.some(
        (pasajero) =>
          Array.isArray(pasajero.access_logs) && pasajero.access_logs.length > 0
      );

      if (!item.vehiculos || !Array.isArray(item.vehiculos)) {
        return false;
      }

      // Verifica si algún pasajero tiene entradas en su access_logs
      const exist_access_vehiculos = item.vehiculos.some(
        (vehiculos) =>
          Array.isArray(vehiculos.access_logs) && vehiculos.access_logs.length > 0
      );

      if (exist_access, exist_access_vehiculos) {
        this.$notify({
          title: "Alerta!",
          text: "No puede cancelar una solicitud con ingresos registrados",
          type: "warning",
        });
        return;
      }
      this.dialogCancell = true;
      this.itemSelected = item;
    },

    async cancellSolicitud() {
      this.loading = true;
      let me = this;
      let _id = this.itemSelected._id;
      await cancelVP(_id, this.motivo_cancell)
        .then((e) => {
          me.$notify({
            title: "¡Éxito!",
            text: "La operación se completo con éxito",
            type: "success",
          });
          me.dialogCancell = false;
          me.listar();
          me.motivo_cancell = "";
        })
        .catch((err) => {
          me.$notify({
            title: "Alerta!",
            text:
              "Por favor, inténtalo de nuevo o verifica los campos obligatorios." + err,
            type: "warning",
          });
        })
        .finally(() => {
          me.loading = false;
        });
    },

    formatFolio(folio, muelle, created) {
      const folio_number = folio.toString().padStart(4, "0");
      const date = new Date(created);
      const day = date.getUTCDate().toString().padStart(2, "0"); // Asegura dos dígitos
      const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
      const year = date.getUTCFullYear();
      let muelle_folio = "";
      if (
        muelle == "CHILTEPEC" ||
        muelle == "MUELLE DE TANQUES" ||
        muelle == "MUELLE PESCADORES CHILTEPEC"
      ) {
        muelle_folio = "CH";
      } else {
        muelle_folio = "FR";
      }
      let clave_muelle = "";
      switch (muelle) {
        case "ESPADAÑAL":
          clave_muelle = "PAR";
          break;
        case "CENTRO DE REPARACIONES NAVALES":
          clave_muelle = "PAR";
          break;
        case "MUELLE PESCADORES FRONTERA":
          clave_muelle = "DEP";
          break;
        case "MUELLE FISCAL":
          clave_muelle = "FIS";
          break;
        case "PARTICULAR":
          clave_muelle = "PAR";
          break;
        case "MUELLE DE TANQUES":
          clave_muelle = "PAR";
          break;
        case "MUELLE PESCADORES CHILTEPEC":
          clave_muelle = "PES";
          break;
        case "SANCHEZ MAGALLANES":
          clave_muelle = "PAR";
          break;
        case "MUELLE DE TANQUES":
          clave_muelle = "PAR";
          break;
        case "MUELLE COSUGO":
          clave_muelle = "PAR";
          break;
        case "MUELLE PRIVADO CARLOS DAVID":
          clave_muelle = "PAR";
          break;

      }
      //113
      if (folio <= 113) {
        return folio_number
      } else {
        let otro_folio = folio_number - 113;
        const folio_number_2 = otro_folio.toString().padStart(4, "0");
        return `${folio_number_2}/${muelle_folio}/${clave_muelle}/${day}${month}${year}`;
      }
    },

    base64ToBlob(base64, contentType) {
      const byteCharacters = atob(base64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, { type: contentType });
    },

    nuevoItem(item) {
      this.limpiar();
      this.agencia = item.agencia;
      this.muelle = item.muelle;
      this.embarcacion = item.embarcacion._id;
      this.tipo = item.tipo;
      this.compania = item.compania;
      this.al_servicio_de = item.al_servicio_de;
      this.retiro_mat = item.retiro_mat;
      this.ingreso_mat = item.ingreso_mat;
      this.pasajeros = JSON.parse(JSON.stringify(item.pasajeros));
      this.vehiculos = JSON.parse(JSON.stringify(item.vehiculos));
      this.dates = Array.isArray(item.fecha) ? [...item.fecha] : [];
      this.nombreArchivo = []; 
      this.nombreArchivo2 = [];
      this.detalles = item.detalles;
      this.editedIndex = false; 
      this.dialogNuevaSolicitud = true;
      this._id = "";
      this.folio = "";
      this.counter = "";
      this.file = [];
      this.file2 = [];
      this.file3 = [];
    },
    async buscar_folio() {
      if (!this.buscarFolio) {
        this.text = "Debes ingresar un folio";
        this.snackbar = true;
        return;
      }
      this.loading = true;
      try {

        let folioVehiculo = this.buscarFolio.split("/")[0];
        const response = await buscarFolioVehiculosPersonal(folioVehiculo);
        if (response) {
          this.nuevoItem(response);
        } else {
          this.text = "No se encontró la solicitud";
          this.snackbar = true;
        }
      } catch (error) {
        this.text = "Error al buscar el folio";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#table_agencia {
  margin-right: 10px;
}

#imagen {
  width: 100px;
}

#imagen2 {
  width: 90px;
}

#fact {
  font-size: 14px;

  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 15%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#fa2 {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 90%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#facarticulo thead {
  padding: 20px;
  background: #31467c;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#solicitante {
  width: 60%;
  border-collapse: collapse;
  border-spacing: 1;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#solicitante thead {
  padding: 20px;
  background: #31467c;
  text-align: center;

  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}

#tituloSolicitante {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}

#tituloPasajeros {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}

.input-filter {
  background-color: rgb(241, 241, 241);
  border-radius: 20px;
  padding: -5px;
  width: 100%;
  height: 40px;
}

.input-filter_seguimiento {
  background-color: rgb(226, 226, 226);
  border-radius: 20px;
  padding: -45px;
  width: 100%;
  height: 25px;
}

.input-filter_title {
  background-color: rgb(29, 29, 29);
  border-radius: 20px;
  padding: -45px;
  color: white;
  width: 100%;
  text-align: center;
  height: 25px;
}

.button-fab {
  bottom: 50px;
  height: 60px;
  position: fixed;
  right: 20px;
  width: 60px;
}

.filter-label {
  color: #b1adad;
  margin-top: -35px;
  margin-left: 40px;
  font-size: 13px;
  font-weight: normal;
}

.filter-chips {
  color: #b1adad;
  padding: 5px;
  margin-top: -41px;
  margin-left: 40px;
}
</style>
